<template>
  <v-dialog
    v-model="dialog"
    persistent
    min-width="900px"
    max-width="1500"
    transition="dialog-transition"
  >
    <template v-slot:activator="{ attrs }">
      <!-- v-on="on" -->
      <v-btn
        small
        text
        rounded
        class="teal white--text"
        v-bind="attrs"
        @click="OpenBalanceDialog"
        :loading="isloading"
      >
        <!-- <v-chip dark color="teal" @click=""> -->
        <slot>
          <v-icon>far fa-eye</v-icon>
        </slot>
        <!-- </v-chip> -->
      </v-btn>
    </template>

    <v-card class="pa-4 teal lighten-3">
      <v-toolbar color="grey lighten-3" dense class="mb-3">
        <v-btn
          icon
          @click="TableView = true"
          :color="TableView ? 'primary' : ''"
        >
          <v-icon>far fa-list-alt</v-icon>
        </v-btn>
        <v-btn
          icon
          @click="TableView = false"
          :color="TableView ? '' : 'primary'"
        >
          <v-icon>fas fa-th</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        Total Price:
        <Strong class="hosdhig">
          {{ price.toLocaleString() }} {{ CashType | MoneySigns }}</Strong
        >
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = false">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-toolbar>

      <v-data-table
        :search="searchItem"
        v-if="TableView"
        :headers="headers2"
        show-select
        v-model="selectedList"
        item-key="_id"
        :items="itemList2"
      >
        <template #top>
          <div>
            <v-toolbar color="pt-3 grey lighten-4">
              <p v-if="checkedPrice">
                {{ checkedPrice.toLocaleString() }} =>
                {{ (price - checkedPrice).toLocaleString() }}
              </p>
              <v-spacer></v-spacer>
              <v-text-field
                dense
                outlined
                solo
                v-model="searchItem"
                name="SearchItemname"
                label="SEARCH ITEM"
                id="SearchItemId"
              ></v-text-field>
            </v-toolbar>
          </div>
        </template>

        <template v-slot:[`item.unitPrice`]="{ item }">
          {{ item.unitPrice && item.unitPrice.toLocaleString() }}
          {{ `/${item.UnitType}` }}
        </template>
        <template v-slot:[`item.total`]="{ item }">
          {{ (item.unitPrice * item.exp).toLocaleString() }}
        </template>
        <template v-slot:[`item.exp`]="{ item }">
          {{ item | DecmalQTY }}
        </template>
        <template v-slot:[`item.UnitQty`]="{ item }">
          {{ `${item.UnitQty}/${item.UnitType}` }}
        </template>
        <template v-slot:[`item.pcsprc`]="{ item }">
          {{ `${(item.unitPrice / item.UnitQty).toLocaleString()}/PCS` }}
        </template>
        <template v-slot:[`item.edite`]="{ item }">
          <EditeInvItem :OnFinish="FillData" :EditeItems="item"></EditeInvItem>
        </template>
      </v-data-table>

      <v-card
        v-else-if="!TableView"
        class="elevation-6 mb-3"
        v-for="(item, index) in itemList"
        :key="'cardView-' + index"
      >
        <v-card-title dense primary-title>
          {{ item.categ }}
          <v-spacer></v-spacer>
          QTY:
          {{ item.lists.reduce((qty, item) => (qty += parseInt(item.exp)), 0) }}
          <v-spacer></v-spacer>
          GROUP PRICE:
          {{
            item.lists
              .reduce((price, item) => (price += item.unitPrice * item.exp), 0)
              .toLocaleString()
          }}
        </v-card-title>
        <v-divider></v-divider>

        <v-data-table
          dense
          :items-per-page="3"
          :headers="headers"
          :items="item.lists"
        >
          <template v-slot:[`item.exp`]="{ item }">
            <!-- {{ item.exp.toLocaleString() }}
            <span class="error--text">
              <strong>{{ item.UnitType }}</strong>
            </span> -->
            {{ item | DecmalQTY }}
          </template>
          <template v-slot:[`item.edite`]="{ item }">
            <BaseDelete
              :DelQuery="{ _id: item._id, OrderCode: item.OrderCode }"
              DelUrl="/stock/Ontheway/itemEdite"
              :OnFinish="FillData"
            >
              <!-- <h4>{{ item }}</h4> -->
              <v-simple-table class="teal darken-3 white--text">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left strong">Categ</th>
                      <th class="text-left">item</th>
                      <th class="text-left">qty</th>
                      <th class="text-left">price</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ item.AccountName }}</td>
                      <td>{{ item.InvName }}</td>
                      <td>{{ item.exp }}</td>
                      <td>{{ item.unitPrice }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <template v-slot:title>
                Delete: {{ item.AccountName }} -
                <strong class="yellow--text">({{ item.InvName }})</strong>
              </template>
            </BaseDelete>
          </template>
        </v-data-table>
      </v-card>
      <v-card-actions>
        <div>
          <AddNewStock :OnFinish="FillData" :OrderCode="query.OrderCode">
            New Item ({{ query.OrderCode }})
            <v-icon right>fas fa-plus</v-icon>
          </AddNewStock>
        </div>
        <v-spacer></v-spacer>
        <div>
          <BaseDelete
            block
            :DelQuery="query"
            DelUrl="/stock/Ontheway/itemEdite/main"
            :OnFinish="FillData"
          >
            <template v-slot:title>
              Order Code: {{ query.OrderCode }}
            </template>
            <template v-slot:DeleteBtn>
              Delete ({{ query.OrderCode }})
              <v-icon right>far fa-trash-alt</v-icon>
            </template>

            <h3 class="text-center">
              {{ query.OrderCode }}
            </h3>
          </BaseDelete>
        </div>
        <!-- <v-btn block color="error" dark
          >Delete <v-icon right>far fa-trash-alt</v-icon></v-btn
        > -->
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  components: {
    EditeInvItem: () => import("./EditeInvItem"),
    AddNewStock: () => import("./NewItem"),
  },
  props: {
    ReqURL: { type: String, required: true },
    price: { type: Number, required: true },
    CashType: { type: String, required: true },
    query: { type: Object, required: true },
    Updated: { type: Function, required: true },
  },
  filters: {
    DecmalQTY(item) {
      const unit = Math.round((item.exp - parseInt(item.exp)) * item.UnitQty);
      if (unit > 0)
        return `${parseInt(item.exp).toLocaleString()} ${
          item.UnitType
        } ${unit} Unit`;
      else return `${parseFloat(item.exp.toFixed(2))} ${item.UnitType}`;
    },
  },
  data() {
    return {
      searchItem: "",
      TableView: true,
      dialog: false,
      isloading: false,
      selectedList: [],
      itemList: [],
      itemList2: [],
      headers2: [
        {
          text: "CATEG",
          value: "AccountName",
          class: "teal darken-3 white--text",
        },
        {
          text: "ITEM",
          align: "left",
          value: "InvName",
          class: "teal darken-3 white--text",
        },
        {
          text: "PCS",
          value: "UnitQty",
          class: "teal darken-3 white--text",
        },
        {
          text: "QTY",
          value: "exp",
          class: "teal darken-3 white--text",
        },
        {
          text: "PCS/PRC",
          value: "pcsprc",
          class: "teal darken-3 white--text",
        },

        {
          text: "PRICE",
          value: "unitPrice",
          class: "teal darken-3 white--text",
        },
        {
          text: "TOTAL",
          value: "total",
          class: "teal darken-3 white--text",
        },
        {
          text: "EDITE",
          value: "edite",
          class: "teal darken-3 white--text",
        },
      ],
      headers: [
        {
          text: "ITEM",
          align: "left",
          value: "InvName",
          class: "teal darken-3 white--text",
        },
        {
          text: "QTY",
          value: "exp",
          class: "teal darken-3 white--text",
        },
        {
          text: "PRICE",
          value: "unitPrice",
          class: "teal darken-3 white--text",
        },
        {
          text: "DELETE",
          value: "edite",
          class: "teal darken-3 white--text",
        },
      ],
    };
  },
  computed: {
    checkedPrice() {
      return this.selectedList.reduce((total, item) => {
        total += item.exp * item.unitPrice;
        // console.log(total);
        return total;
      }, 0);
    },
  },
  methods: {
    FillData(val, isUpdate = false) {
      if (isUpdate) this.Updated();
      this.itemList2 = val;
      this.itemList = val.reduce((categ, item) => {
        if (!categ[item.AccountName])
          categ[item.AccountName] = {
            categ: item.AccountName,
            lists: [],
          };
        categ[item.AccountName].lists = [
          ...(categ[item.AccountName].lists || []),
          item,
        ];
        return categ;
      }, {});
    },
    OpenBalanceDialog() {
      // this.dialog = true;
      try {
        this.isloading = true;

        // },
        // ShowBalance() {
        this.itemList = [];
        // console.log(ID);
        this.$store
          .dispatch("FIND_BY_VALUE", {
            url: this.ReqURL,
            query: this.query,
          })
          .then(result => {
            this.dialog = true;
            this.isloading = false;

            this.FillData(result.data);
            // console.log(this.itemList);
          })
          .catch(error => {
            console.log(error);
            //   this.clickedID = "";
            this.isloading = false;
          });
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style scoped>
.hosdhig {
  /* border-bottom: solid double 2px black; */
  border-bottom: double black;
}
</style>
